import { postAny } from "../services/api";
import { config } from "../config/environment";

const authenticate = async (): Promise<string | null> => {
    const credentials = {
        usr: 'WebBookingClient',
        pwd: '.L3tsG3tIns1d34@Wh1l3*#'
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await postAny(`${config.API_BASE_URL}/login`, { data: credentials, ...headers });
        return response.data.token; // Assuming the token is returned in the 'token' field
    } catch (error) {
        console.error('Authentication failed:', error);
        return null;
    }
};

export default authenticate;